import { createWebHistory, createRouter } from "vue-router"
import AvaLeht from "@/components/AvaLeht.vue"
import SuhtlusAmetnikugaLeht from "@/components/SuhtlusAmetnikugaLeht.vue"
import MaandumisLeht from "@/components/MaandumisLeht.vue";
import { AuthTeenus } from "@/core/auth-teenus";
import HooldusKavaLeht from "@/components/HoolduskavaLeht.vue";
import OigusedJaKohustusedLeht from "@/components/OigusedJaKohustusedLeht.vue";
import UldkasulikTooLeht from "@/components/UldkasulikTooLeht.vue";
import ElektroonilineValveLeht from "@/components/ElektroonilineValveLeht.vue";
import DokumendidLeht from "@/components/DokumendidLeht.vue";
import JuurdepaasPoleLubatud from "@/components/JuurdepaasPoleLubatud.vue";
import SessioonAegunudLeht from "@/components/SessioonAegunudLeht.vue";
import TingimusedKinnitamata from "@/components/TingimusedKinnitamata.vue";
import LigipaasetavusLogiSisseLeht from "@/components/ligipaasetavus/LigipaasetavusLogiSisseLeht.vue";
import { useKasutajaStore } from '@/stores/kasutajaStore';
import LigipaasetavusTyhiPaigutusLeht from "@/components/ligipaasetavus/LigipaasetavusTyhiPaigutusLeht.vue";
import LigipaasetavusKrhpPaigutusLeht from "@/components/ligipaasetavus/LigipaasetavusKrhpPaigutusLeht.vue";


function authGuard(to: any) {
    const userStore = useKasutajaStore();
    const _authTeenus = new AuthTeenus();
    if (!_authTeenus.onSisseLogitud) {
        return "/";
    }
    else if (!userStore.onVang || !userStore.onKasutusOigus) {
        return "/juurdepaasPoleLubatud";
    }
    else if (!userStore.onTingimustegaNous) {
        return "/tingimusedkinnitamata";
    }
}

function authGuardPlain(to: any) {
    const _authTeenus = new AuthTeenus();
    if (!_authTeenus.onSisseLogitud) {
        return "/";
    }
}

function hoolduskavaGuard(to: any) {
    const userStore = useKasutajaStore();
    if (!userStore.onHoolduskavaNahtav) {
        return "/avaleht";
    }
}

function yktGuard(to: any) {
    const userStore = useKasutajaStore();
    if (!userStore.onYktNahtav) {
        return "/avaleht";
    }
}

function nousolekGuard(to: any) {
    const userStore = useKasutajaStore();
    if (userStore.onTingimustegaNous) {
        return "/avaleht";
    }
}

const routes = [
    {
        path: "/",
        name: "MaandumisLeht",
        component: MaandumisLeht,
    },
    // {
    //     // see on TARA poolt tagasi tuleva päringu callback
    //     // tulevikus võiks selle teha /Authenticate
    //     path: "/aet/Login/Authenticate",
    //     name: "TaraResultCallBack",
    //     component: MaandumisLeht,
    // },
    {
        path: '/ligipaasetavus',
        name: 'LigipaasetavusLogiSisseLeht',
        component: LigipaasetavusLogiSisseLeht,
    },
    {
        path: '/avaleht/ligipaasetavus',
        name: 'LigipaasetavusKrhpPaigutusLeht',
        component: LigipaasetavusKrhpPaigutusLeht,
    },
    {
        path: "/sessioonaegunud",
        name: "SessioonAegunudLeht",
        component: SessioonAegunudLeht,
    },
    {
        path: "/juurdepaasPoleLubatud",
        name: "JuurdepaasPoleLubatud",
        component: JuurdepaasPoleLubatud,
        beforeEnter: [authGuardPlain],
    },
    {
        path: "/juurdepaasPoleLubatud/ligipaasetavus",
        name: "LigipaasetavusTyhiPaigutusLeht",
        component: LigipaasetavusTyhiPaigutusLeht,
        beforeEnter: [authGuardPlain],
    },
    {
        path: "/tingimusedkinnitamata",
        name: "TingimusedKinnitamata",
        component: TingimusedKinnitamata,
        beforeEnter: [authGuardPlain, nousolekGuard],
    },
    {
        path: "/avaleht",
        name: "Avaleht",
        component: AvaLeht,
        beforeEnter: [authGuard],
    },
    {
        path: "/poordumised",
        name: "Pöördumised",
        component: SuhtlusAmetnikugaLeht,
        beforeEnter: [authGuard],
    },
    {
        path: "/hoolduskava",
        name: "Hoolduskava",
        component: HooldusKavaLeht,
        beforeEnter: [authGuard, hoolduskavaGuard],
    },
    {
        path: "/oigused_ja_kohustused",
        name: "oigused_ja_kohustused",
        component: OigusedJaKohustusedLeht,
        beforeEnter: [authGuard],
    },
    {
        path: "/uldkasulik_Tooo/:aluseId(\\d+)?/:broneeringuId(\\d+)?/:ajakavaId(\\d+)?/",
        name: "uldkasulik_Too",
        props: (route: any) => ({
            aluseId: route.params.aluseId ? +route.params.aluseId : undefined,
            broneeringuId: route.params.broneeringuId ? +route.params.broneeringuId : undefined,
            ajakavaId: route.params.ajakavaId ? +route.params.ajakavaId : undefined
        }),
        component: UldkasulikTooLeht,
        beforeEnter: [authGuard, yktGuard],
    },
    {
        path: "/uldkasulik_Too/:ajakavaRidaId(\\d+)*",
        name: "uldkasulik_Too",
        props: (route: any) => ({
            aluseId: route.params.ajakavaRidaId && route.params.ajakavaRidaId[0] ? +route.params.ajakavaRidaId[0] : undefined,
            broneeringuId: route.params.ajakavaRidaId && route.params.ajakavaRidaId[1] ? +route.params.ajakavaRidaId[1] : undefined,
            ajakavaId: route.params.ajakavaRidaId && route.params.ajakavaRidaId[2] ? +route.params.ajakavaRidaId[2] : undefined
        }),
        component: UldkasulikTooLeht,
        beforeEnter: [authGuard, yktGuard],
    },
    {
        path: "/elektrooniline_valve/:ajakavaRidaId(\\d+)*",
        name: "elektrooniline_valve",
        component: ElektroonilineValveLeht,
        beforeEnter: [authGuard],
    },
    {
        path: "/dokumendid",
        name: "dokumendid",
        component: DokumendidLeht,
        beforeEnter: [authGuard],
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
